(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/andra-chansen-banners/assets/javascripts/helpers/handlebarhelpers.js') >= 0) return;  svs.modules.push('/components/numbergames/andra-chansen-banners/assets/javascripts/helpers/handlebarhelpers.js');

'use strict';

if (svs.isServer) {
  registerHelpers(require('hbs'));
} else {
  registerHelpers(Handlebars);
}
function registerHelpers(hbs) {
  hbs.registerHelper('isSingleChance', function (chances, options) {
    if (typeof options.fn !== 'function') {
      return chances === 1;
    }
    if (chances === 1) {
      return options.fn(this);
    }
    if (typeof options.inverse === 'function') {
      return options.inverse(this);
    }
  });
  hbs.registerHelper('andraChansenOngoingLink', drawnum => {
    const urlMapping = svs.core.urlMapping.get('andrachansen_OngoingBets');
    if (!urlMapping) {
      svs.numbergames.andra_chansen_banners.logger.warn('Missing url mapping for andrachansen_OngoingBets');
      return svs.core.urlMapping.get('myBetsHome');
    }
    let url;
    if (drawnum) {
      url = urlMapping.replace(':currentDrawNumber', drawnum);
    } else {
      url = urlMapping.replace(':currentDrawNumber/', '');
    }
    return url;
  });
  hbs.registerHelper('relativeWeekday', date => {
    date = new Date(date);
    const daysDiff = Math.abs(dateFns.differenceInCalendarDays(date, new Date()));
    const day = dateFns.format(date, 'EEEE', {
      locale: dateFns.locales.sv
    });
    if (daysDiff < 7) {
      return day;
    }
    if (daysDiff < 14) {
      return "n\xE4sta ".concat(day);
    }
    return "".concat(day, " ").concat(dateFns.format(date, 'd/M'));
  });
}

 })(window);